import type { BlogChromeVisitor } from "../blog-variant";
import "@tento-ui/brand/blog/blog-page-shell";
import { BlogPageShell } from "@tento-ui/brand/blog/blog-page-shell";

export class BlogChromeImpl implements BlogChromeVisitor {
  makeLayout(parts: {
    header: HTMLElement;
    breadcrumb: HTMLElement;
    footer: HTMLElement;
  }): HTMLElement {
    const $shell = BlogPageShell.make();

    parts.header.slot = "nav";
    parts.breadcrumb.slot = "breadcrumb";
    parts.header.appendChild(parts.breadcrumb);

    parts.footer.slot = "footer";

    $shell.append(parts.header, parts.footer);
    return $shell;
  }
}
